import(/* webpackMode: "eager", webpackExports: ["InsightsScreen"] */ "/app/apps/platform-web/components/talent/screens/InsightsScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["V2GuideScreen"] */ "/app/apps/platform-web/components/v2/screens/V2GuideScreen.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
